import { Box, Container, Stack, Typography } from "@mui/material";
import Subscription from "@/templates/Subscription";
import { BackButton } from "@/organism";
import useCreate from "./useCreate";

export const Create = () => {
  const { handleSubmit } = useCreate();

  return (
    <Container maxWidth={"xl"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Stack direction={"column"} gap={1}>
          <BackButton to={"/subscription"}>구독 상품 목록</BackButton>
          <Typography
            component={"h1"}
            variant="h5"
            fontWeight={"bold"}
            gutterBottom
          >
            구독 상품 등록
          </Typography>
        </Stack>
      </Box>
      <Subscription.CreateForm onSubmit={handleSubmit} />
    </Container>
  );
};
